import React from 'react';
import {useToggleBoolean} from '../../../../../hooks/useToggleBoolean';
import ModelCardExpanded from './ModelCardExpanded';
import ModelCardCollapsed from './ModelCardCollapsed';
import {SharedModelCardProps} from './types';
import {isModelDTO, StoredModel} from '../../../../../store/model';
import ModelCardRestricted from './ModelCardRestricted';
import {ModelDTO} from 'hemwb-api/dist/models/ModelDTO';

export type ModelCardProps = Omit<SharedModelCardProps, 'model'> & {
  expanded?: boolean;
  model: StoredModel | null;
};

export const ModelCard: React.FC<ModelCardProps> = ({expanded, model, ...restProps}) => {
  const [isExpanded, toggleIsExpanded] = useToggleBoolean(!!expanded);
  const isExpandable = expanded !== undefined;

  if (model && !isModelDTO(model)) {
    return <ModelCardRestricted />;
  }

  if (isExpanded) {
    return (
      <ModelCardExpanded
        model={model as ModelDTO | null}
        onClickCollapse={isExpandable ? toggleIsExpanded : undefined}
        {...restProps}
      />
    );
  }

  return (
    <ModelCardCollapsed
      model={model as ModelDTO | null}
      onClickExpand={isExpandable ? toggleIsExpanded : undefined}
      {...restProps}
    />
  );
};
